export default {
  // 闪送员意向招募城市信息提交
  preferSubmit: '/v3/recruit/preferSubmit',

  // [通用数据] - 开通城市查询
  cities: '/courier/api/v2/cities',

  // 发短信接口
  sendSmsCode: '/passport/captcha/sendMobileCaptcha',

  // 根据短信换取token
  getCodeBySms: '/passport/login/getCodeBySms',
  courierAge: '/v3/recruit/courierAge' // 查询年龄
}
